import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "../components/ComingSoon";

export const Route = createFileRoute("/verkfaeri/spalikan-orkunotkun")({
  component: ForecastPage,
});

function ForecastPage() {
  return (
    <ComingSoon
      name="Spálíkan orkunotkunar"
      glyph="∿"
      color="#7A5AF0"
      bg="#EFEBFE"
      desc="Greiningarherbergi svítunnar — innlestur raunnotkunar, þjálfun spálíkans, samanburður á m², m³, kWh og GWh, sveitarfélagayfirlit og útflutningur."
    />
  );
}
